(ns practitest.frontend.common.css-vars
  (:require [clojure.string :as str]))

(defn resolve-color
  "Resolves a var(--pt-color-x) reference to its literal computed color, needed for Chart.js/canvas."
  ([css-value] (resolve-color css-value (.-documentElement js/document)))
  ([css-value element]
   (when css-value
     (if-let [[_ var-name] (re-matches #"\s*var\((--[^,)]+)(?:,.*)?\)\s*" css-value)]
       (let [resolved (str/trim (.getPropertyValue (js/getComputedStyle element) var-name))]
         (if (str/blank? resolved) css-value resolved))
       css-value))))
